import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ViewPath } from '@ContractBuilder/contract-builder-header/constants';
import { useDatapointsStore } from '@ContractBuilder/store/datapoints.store';
import { useEntityStore } from '@ContractBuilder/store/entity.store';
import { useDocumentLocation } from '@src/hooks';

export const useContractFormPreventableLink = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const { isFormView } = useDocumentLocation();

  const reloadSubmission = useEntityStore(({ reloadSubmission }) => reloadSubmission);
  const { isDirty, onSubmit, onFormReset } = useDatapointsStore(({ isDirty, onSubmit, onFormReset }) => ({
    isDirty,
    onSubmit,
    onFormReset,
  }));

  const [isBlocked, setIsBlocked] = useState(false);
  const [nextRoute, setNextRoute] = useState<string>(ViewPath.Form);

  const onNavigate = (to: string) => {
    setIsBlocked(false);
    // A target carrying its own query (e.g. back to a saved view) must not inherit this page's params.
    navigate(to.includes('?') ? to : to + search);
  };

  const onReset = () => {
    setIsBlocked(false);
    setNextRoute(ViewPath.Form);
  };

  const handleReloadSubmission = (to: string) => {
    if (to === ViewPath.Form || to === ViewPath.Contract) {
      reloadSubmission();
    }
  };

  const onLinkClick = (to: string) => {
    if (isDirty && isFormView) {
      setNextRoute(to);
      setIsBlocked(true);
    } else {
      onNavigate(to);
      handleReloadSubmission(to);
    }
  };

  const onDisregardChanges = () => {
    onFormReset();
    onNavigate(nextRoute);
    handleReloadSubmission(nextRoute);
  };

  const onSaveChanges = async () => {
    await onSubmit();
    return onNavigate(nextRoute);
  };

  return {
    isBlocked,
    onDisregardChanges,
    onLinkClick,
    onReset,
    onSaveChanges,
  };
};
